<template>
  <div class="pc-panel" ref="panel">
    <div class="hide-btn" @click="hidePanel()" :class="{ isShow: isShowPanel }">
      {{ isShowPanel ? "隐藏统计" : "显示统计" }}
    </div>
    <div class="pc-panel-data" :class="{ hide: !isShowPanel }">
      <!-- 数据统计 -->
      <div class="pc-panel-statistics">
        <h2>{{ data.title }}</h2>
        <div class="pc-panel-statistics-count">
          <div v-for="(item, index) in data.count" :key="index">
            <h1 :class="{ light: index == 1 }">{{ item.count }}</h1>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <!-- 浏览趋势表 -->
      <ChartBrowseTrend
        class="pc-panel-browseTrend"
        :whichModule="whichModule"
      />
    </div>
  </div> 
</template>



<script>
import {getModuleStatistics_Api} from "../../../apis/statistics.api"
import ChartBrowseTrend from "./ChartBrowseTrend.vue";

export default {
  components: {
    ChartBrowseTrend,
  },
  props: { whichModule: String, data: Object },
  data() {
    return {
      isShowPanel: true,
    };
  },
  methods: {
    hidePanel() {
      this.isShowPanel = !this.isShowPanel;
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-panel {
  position: relative;
  min-height:1px;
   .hide-btn {
      position: absolute;
      cursor: pointer;
      line-height: 30px;
      text-align: center;
      right: 0px;
      top: -40px;
      font-size: 14px;
    }
    .isShow {
      color: $lightenYellow;
      top: -80px;
    }
  .pc-panel-data {
    position: relative;
    margin-top: 40px;
    height: 400px;
    display: flex;
    justify-content: space-between;
    .pc-panel-statistics {
      flex-shrink: 1;
      width: calc(100% - 940px);
      min-width:200px;
      height: 100%;
      box-shadow: $boxshadow;
      padding: 40px 25px 0 25px;
      border-radius: 4px;
      .pc-panel-statistics-count {
        h1 {
          font-size: 60px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #5470c6;
          line-height: 60px;
          margin-top: 37px;
          text-align: center;
        }
        p {
          margin-top: 10px;
          color: $mainTitle;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #434343;
          line-height: 21px;
        }
        .light {
          margin-top: 48px;
          color: #fac858;
        }
      }
    }
    .pc-panel-browseTrend {
      flex-shrink: 0;
      margin-left:20px;
      width: 920px;
    }
    .pc-panel-yeartarget {
      flex-shrink: 0;
      width: 200px;
      height: 100%;
      box-shadow: $boxshadow;
      padding: 40px 25px 0 25px;
      border-radius: 4px;
      position: relative;
      > h2 {
        font-size: 20px;
        color: $mainTitle;
        padding-bottom: 20px;
        border-bottom: 1px solid $border-color;
      }
      .chartRadar {
        overflow: hidden;
      }
      ul {
        padding: 0 30px;
        position: absolute;
        left: 0;
        bottom: 27px;
        display: flex;
        justify-content: space-between;
        li {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .firstline,
          .secondline,
          .finishNum {
            margin-bottom: 10px;
          }

          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 14px;
            white-space: nowrap;
          }
          div span,
          span:nth-of-type(2) {
            font-size: 20px;
          }
        }
        li:nth-of-type(1) {
          .finishNum {
            color: $visitorVolumeSmall;
          }
        }
        li:nth-of-type(2) {
          margin-left: 30px;
          div {
            display: inline-block;
            vertical-align: top;
          }
          .goal {
            display: flex;
            /deep/ .el-input {
              .el-input__inner {
                width: 80px;
                padding:0px 5px;
                height: 25px;
              }
            }
          }
          .finishNum {
            color: $timeBtn;
          }
          .el-icon-edit {
            color: $iconFinish;
            cursor: pointer;
            margin-left: 4px;
            margin-top:-10px;
            align-self: center;
          }
        }
      }
    }
   
  }
  .hide{
    display: none;
  }


}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/Statistical/StatisticalPanel.vue